import { createStore, applyMiddleware } from "redux";
import createSagaMiddleware from "redux-saga";
import reducers from "../state";
import sagas from "../sagas";

export default function configureStore(initialState = {}) {
  const middlewares = [];
  const sagaMiddleware = createSagaMiddleware();
  middlewares.push(sagaMiddleware);
  let createStoreWithMiddleware = applyMiddleware(...middlewares);
  const finalCreateStore = createStoreWithMiddleware(createStore);
  const store = finalCreateStore(reducers, initialState);
  sagaMiddleware.run(sagas);

  return store;
}
